export default "__VITE_ASSET__BGITbYXb__"